import { render, staticRenderFns } from "./loginIframe.vue?vue&type=template&id=a529061a&scoped=true"
import script from "./loginIframe.vue?vue&type=script&lang=js"
export * from "./loginIframe.vue?vue&type=script&lang=js"
import style0 from "./loginIframe.vue?vue&type=style&index=0&id=a529061a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a529061a",
  null
  
)

export default component.exports